import { render, staticRenderFns } from "./order_send.vue?vue&type=template&id=22ea87ca&scoped=true"
import script from "./order_send.vue?vue&type=script&lang=js"
export * from "./order_send.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea87ca",
  null
  
)

export default component.exports